(function () {
    'use strict';

    angular.module('app').factory('BusinessService', BusinessService);

    BusinessService.$inject = ['$rootScope', 'API', '$filter', 'NotifyService'];

    function BusinessService($rootScope, API, $filter, NotifyService) {
        var service = {};

        var _req_gc = ['BUSINESS', 'ACCOUNTS', 'LEGAL_INFO'];

        function initVars() {
            if (!$rootScope.TARIFF_LIMITATION)
                $rootScope.TARIFF_LIMITATION = {};
        }

        $rootScope.$on('user-login', function () {
            initVars();
        });

        $rootScope.$on('user-register', function () {
            initVars();
        });

        $rootScope.$on('user-logout', function () {
            for (var i in _req_gc)
                $rootScope[_req_gc[i]] = null;
        });

        /**
         * Base function for get business info
         * @param needTariff
         * @param callback
         */
        function getBusiness(needTariff, callback) {
            if ($rootScope.BUSINESS && !needTariff) {
                callback(true, $rootScope.BUSINESS);
            } else {
                var url = '/business?ext=true';
                if (needTariff) {
                    url = url + '&tariff=true';
                }
                API.get(url, function (success, data) {
                    if (success) {
                        $rootScope.BUSINESS = data;
                        $rootScope.ENV.business = data;
                    }
                    callback(success, data);
                });
            }
        }

        /**
         * Get business info
         */
        service.Get = function (callback) {
            getBusiness(false, callback);
        };

        /**
         * Get business info with tariff plan info
         */
        service.GetWithTariff = function (callback) {
            getBusiness(true, callback);
        };

        /**
         * Get business dashboard info
         */
        service.Dashboard = function (callback) {
            API.get('/business/dashboard', callback, true);
        };

        /**
         * Create new business with other depends business-units
         */
        service.Create = function (post_data, callback) {
            API.post('/business?ext=true', post_data, function (success, data) {
                if (success) {
                    $rootScope.BUSINESS = data;
                    NotifyService.Success(data.message, false);
                }
                callback(success, data);
            });
        };

        /**
         * Change main info for business
         */

        /**
         * Check exists referral code
         */
        service.CheckReferralCode = function (code, callback) {
            API.get('/business/check_referral/' + code, callback);
        };

        /**
         * Return Business general status
         */
        service.GeneralStatus = function (callback) {
            API.get('/business/general_status', callback, true);
        };

        /**
         * Return Business sms tariff details

         */
        service.SMSTariff = function (params, callback) {
            API.get('/business/sms_tariff?' + paramsToUrlQueryEncodeURIComponent(params), callback);
        };

        service.ViberTariff = function (params, callback) {
            API.get('/business/viber_tariff?' + paramsToUrlQueryEncodeURIComponent(params), callback);
        };

        /**
         * Return Business tariff details by month
         * @param period: Report period in format YY-MM-DD
         * @param callback: Callback
         * @param language: set language for header,  we need it for download correct PDF with right public_title
         */
        service.TariffDetails = function (period, callback, language) {
            var url = '/business/tariff_details';
            if (period) url = '{0}?date={1}'.format(url, period);
            API.get(url, callback, null, null, language);
        };

        service.TariffChange = function (callback) {
            API.patch('/business/tariff_change_to_base', null, function (success, data) {
                callback(success, data);
            });
        };

        service.TransactionCheck = function (transactionId, callback) {
            API.get(`/transactions/${transactionId}/check`, callback);
        };

        // ===========================================  SPECIAL ACCOUNTS  ==============================================

        // TODO change to SpecialAccountsScope
        service.SpecialAccounts = function (callback) {
            API.get('/business/special_account', function (success, data) {
                if (success) {
                    $rootScope.ACCOUNTS = data;
                }
                callback(success, data);
            });
        };
        service.SpecialAccountsParams = function (params, callback) {
            if (!params) {
                params['scope'] = 'retail';
            }
            API.get('/business/special_account?' + paramsToUrlQueryEncodeURIComponent(params), function (success, data) {
                if (success) {
                    $rootScope.ACCOUNTS = data;
                }
                callback(success, data);
            });
        };

        service.SpecialAccount = function (id, callback) {
            API.get('/business/special_account/' + id, function (success, data) {
                if (success) {
                    updateItemInList($rootScope.ACCOUNTS, data);
                }
                callback(success, data);
            });
        };

        service.getSpecialAccountGoods = function (id, callback) {
            API.get('/business/special_account/' + id + '/goods', function (success, data) {
                callback(success, data);
            });
        };

        service.SpecialAccountEdit = function (id, post_data, callback) {
            API.patch('/business/special_account/' + id, post_data, function (success, data) {
                if (success) {
                    updateItemInList($rootScope.ACCOUNTS, data);
                }
                callback(success, data);
            });
        };

        service.SpecialAccountAdd = function (post_data, callback) {
            API.post('/business/special_account', post_data, function (success, data) {
                if (success) {
                    updateItemInList($rootScope.ACCOUNTS, data);
                }
                callback(success, data);
            });
        };

        service.SpecialAccountCustomers = function (account_id, loyalty_id, params, callback) {
            API.get('/business/special_account/' + account_id + '/loyalty/' + loyalty_id + '/customers?' + paramsToUrlQueryEncodeURIComponent(params), function (success, data) {
                callback(success, data);
            });
        };

        service.SpecialAccountImportCustomers = function (account_id, loyalty_id, data, callback) {
            API.patch('/business/special_account/' + account_id + '/loyalty/' + loyalty_id + '/customers', data, function (success, data) {
                callback(success, data);
            });
        };

        service.SpecialAccountEditCustomers = function (account_id, loyalty_id, params, data, callback) {
            API.patch('/business/special_account/' + account_id + '/loyalty/' + loyalty_id + '/customers?' + paramsToUrlQueryEncodeURIComponent(params), data, function (success, data) {
                callback(success, data);
            });
        };

        // ===========================================    PAYMENT    ===================================================

        service.AccountDisableAutoPay = function (callback) {
            API.delete('/business/regular_payment', null, function (success, data) {
                if (success) {

                }
                callback(success, data);
            });
        }

        service.AccountRefillLiqpayNew = function (post_data, callback) {
            API.post('/business/liqpay/create_payment_new', post_data, function (success, data) {
                if (success) {

                }
                callback(success, data);
            });
        };

        service.AccountRecurrentLiqpay = function (post_data, callback) {
            API.post('/business/liqpay/regular_payment', post_data, function (success, data) {
                if (success) {

                }
                callback(success, data);
            });
        };

        service.AccountRefillWayForPay = function (post_data, callback) {
            API.post('/business/wayforpay/create_payment_new', post_data, function (success, data) {
                if (success) {

                }
                callback(success, data);
            });
        };

        service.AccountRecurrentWayForPay = function (post_data, callback) {
            API.post('/business/wayforpay/regular_payment', post_data, function (success, data) {
                if (success) {

                }
                callback(success, data);
            });
        };

        service.AccountRefillPayPro = function (post_data, callback) {
            API.post('/business/paypro/create_payment_new', post_data, function (success, data) {
                if (success) {

                }
                callback(success, data);
            });
        };

        service.AccountBonusesRedeem = function (data, callback) {
            API.post('/business/bonuses_redeem', data, callback);
        };

        service.BaseSettingsStripe = function (callback) {
            API.get('/business/stripe/base_payment_info', function (success, data) {
                callback(success, data);
            });
        };

        service.AccountRefillStripeNew = function (post_data, callback) {
            API.post('/business/stripe/create_payment_new', post_data, function (success, data) {
                if (success) {

                }
                callback(success, data);
            });
        };

        service.AccountRefillStripeSaved = function (post_data, callback) {
            API.post('/business/stripe/create_payment_by_saved', post_data, function (success, data) {
                if (success) {

                }
                callback(success, data);
            });
        };

        service.AccountRefillFlutterwaveNew = function (post_data, callback) {
            API.post('/business/flutterwave/create_payment_new', post_data, function (success, data) {
                if (success) {

                }
                callback(success, data);
            });
        };

        // ===========================================  LEGAL INFO  ====================================================

        service.LegalInfo = function (callback) {
            if ($rootScope.LEGAL_INFO) {
                callback(true, $rootScope.LEGAL_INFO);
            } else {
                API.get('/business/legal_info', function (success, data) {
                    if (success) {
                        $rootScope.LEGAL_INFO = data;
                    }
                    callback(success, data);
                });
            }
        };

        service.LegalInfoEdit = function (data, callback) {
            API.patch('/business/legal_info', data, function (success, data) {
                if (success) {
                    $rootScope.LEGAL_INFO = data;
                }
                callback(success, data);
            });
        };

        // ===========================================  MESSAGING INFO  ====================================================
        service.SendMessageToIncust = function (post_data, callback) {
            API.post('/message/system', post_data, function (success, data) {
                if (success) {

                }
                callback(success, data);
            });
        };

        // ===========================================  CURRENCY INFO  ====================================================
        service.CurrencyList = function (id, callback) {
            var url = '/business/currencies';
            if (id) url += '?loyalty_id={0}'.format(id, url);
            API.get(url, callback);
        };

        // ========================================  ADDITIONAL SETTINGS  ==============================================

        service.Settings = function (callback) {
            API.get('/business/settings', function (success, data) {
                callback(success, data);
            }, false);
        };

        service.SettingsEdit = function (data, callback) {
            API.patch('/business/settings', data, function (success, data) {
                callback(success, data);
            });
        };

        service.UploadPhoto = function (data, callback) {
            API.postImage('/business/settings/photo', data, function (success, data) {
                callback(success, data);
            });
        };

        service.DeletePhoto = function (callback) {
            API.delete('/business/settings/photo', function (success, data) {
                callback(success, data);
            });
        };

        // ========================================  CUSTOM PREFERENCES  ==============================================

        service.GetCustomPreference = function (data, callback) {
            API.post('/business/custom/preferences', data, function (success, data) {
                callback(success, data);
            });
        };

        service.EditCustomPreference = function (data, callback) {
            API.patch('/business/custom/preferences', data, function (success, data) {
                callback(success, data);
            });
        };

        service.GetSettingMenu = function (callback) {
            API.post('/business/custom/preferences', {
                name: 'MENU_SETTINGS_V2'
            }, function (success, data) {
                callback(success, data);
            });
        };

        service.SetSettingsMenu = function (value, callback) {
            API.patch('/business/custom/preferences', {
                name: 'MENU_SETTINGS_V2',
                value: value
            }, function (success, data) {
                callback(success, data);
            });
        };
        service.GetDeniedMenu = function (callback) {
            var platform = 'incust';

            var isPrimeFuel = appConfig.platformParams.main_site.en === 'prime-fuel.com';
            var isTmyasa = appConfig.platformParams.main_site.en === 'tmyasa.com.ua';
            var isGLO = appConfig.platformParams.main_site.en === 'myglo.com.ua';
            var isParimatch = appConfig.platformParams.main_site.en === 'pmclub.bet';
            var isInCust = appConfig.platformParams.main_site.en === 'incust.com';
            var isTestApi = (appConfig.apiBase.indexOf('//testapi.') !== -1);

            if (isPrimeFuel) {
                platform = 'prime-fuel';
            } else if (isTmyasa) {
                platform = 'tmyasa';
            } else if (isGLO) {
                platform = 'glo';
            } else if (isParimatch) {
                platform = 'pmclub';
            }
            var data = {};
            var success = true;

            switch (platform) {
                case 'prime-fuel':
                    data['feedback'] = true;
                    data['feedbacks'] = true;
                    data['feedback-sources'] = true;
                    data['coupons-exchange'] = true;
                    data['gift-cards'] = true;
                    data['prepaid'] = true;
                    data['tariff'] = true;
                    data['partners'] = true;
                    data['reseller'] = true;
                    break;
                case 'tmyasa':
                    data['price-groups'] = true;
                    data['corporate-accounts'] = true;
                    data['fuel-controllers'] = true;
                    data['coupons-exchange'] = true;
                    data['gift-cards'] = true;
                    data['tariff'] = true;
                    data['partners'] = true;
                    break;
                case 'glo':
                    data['feedback'] = true;
                    data['feedbacks'] = true;
                    data['feedback-sources'] = true;
                    data['fuel-controllers'] = true;
                    data['tariff'] = true;
                    data['partners'] = true;
                    break;
                case 'pmclub':
                    data['feedback'] = true;
                    data['feedbacks'] = true;
                    data['feedback-sources'] = true;
                    data['fuel-controllers'] = true;
                    data['tariff'] = true;
                    data['partners'] = true;
                    break;
            }

            callback(success, data);
        };
        // ========================================  TARIFF UPGRADE/DOWNGRADE  ==============================================

        service.GetAvailableTariffs = function (params, callback) {
            API.get('/business/tariffs_available?' + paramsToUrlQueryEncodeURIComponent(params), function (success, data) {
                callback(success, data);
            });
        };

        service.SetTariff = function (data, callback) {
            API.patch('/business/tariff_set', data, function (success, data) {
                callback(success, data);
            });
        };

        // External access

        /**
         * Get business data access list
         *
         * @param {requestCallback} callback - The callback that handles the response.
         */
        service.GetExternalAccessList = function (callback) {
            API.get(`/external_data_access`, function (success, data) {
                callback(success, data);
            });
        }

        /**
         * Get business data access
         *
         * @param {requestCallback} callback - The callback that handles the response.
         */
        service.GetExternalAccessScope = function (callback) {
            var url = '/external_data_access/scopes?object_type=business';
            API.get(url, function (success, data) {
                callback(success, data);
            });
        };

        /**
         * Add business data access
         *
         * @param {Object} data - Loyalty data access
         * @param {requestCallback} callback - The callback that handles the response.
         */
        service.AddExternalAccess = function (data, callback) {
            var url = '/external_data_access';
            API.post(url, data, function (success, data) {
                callback(success, data);
            });
        };

        /**
         * Delete business data access
         *
         * @param {string} accessId - Access ID
         * @param {requestCallback} callback - The callback that handles the response.
         */
        service.RemoveExternalAccess = function (accessId, callback) {
            var url = '/external_data_access/{0}'.format(accessId);
            API.del(url, function (success, data) {
                callback(success, data);
            });
        };

        /**
         * Return business data access
         *
         * @param {string} accessId - Access ID
         * @param {requestCallback} callback - The callback that handles the response.
         */
        service.GetExternalAccess = function (accessId, callback) {
            var url = '/external_data_access/{0}'.format(accessId);
            API.get(url, function (success, data) {
                callback(success, data);
            });
        };

        /**
         * Update business data access
         *
         * @param {string} accessId - Access ID
         * @param {Object} data - Loyalty data access
         * @param {requestCallback} callback - The callback that handles the response.
         */
        service.UpdateExternalAccess = function (accessId, data, callback) {
            var url = '/external_data_access/{0}'.format(accessId);
            API.patch(url, data, function (success, data) {
                callback(success, data);
            });
        };

        return service;
    }

})();

